import { render, staticRenderFns } from "./GiftCardCreate.vue?vue&type=template&id=1b616cf9&scoped=true&"
import script from "./GiftCardCreate.vue?vue&type=script&lang=js&"
export * from "./GiftCardCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b616cf9",
  null
  
)

export default component.exports